import { createApi } from '@reduxjs/toolkit/query/react';
import { GuidT } from '@/types/common';
import {
    SuitcaseModelIF,
    SuitcaseModelDataResultIF,
    CreateSuitcaseIF,
    UpdateSuitcaseIF,
    GetSuitcasesParametersIF,
} from '@/api/suitcasesApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

//TODO Добавить инвалидаию на обновление клозинг и оутфит
export const suitcasesApi = createApi({
    reducerPath: 'suitcasesApi',
    baseQuery: fetchRestApiQuery('/Suitcases'),
    tagTypes: ['Suitcases'],
    endpoints: (builder) => ({
        getSuitcases: builder.query<
            SuitcaseModelDataResultIF,
            GetSuitcasesParametersIF
        >({
            query: (parameters) => ({
                url: '',
                params: parameters,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                          { type: 'Suitcases', id: 'LIST' },
                          ...result.data.map((item) => ({
                              type: 'Suitcases' as const,
                              id: item.guid,
                          })),
                      ]
                    : [{ type: 'Suitcases', id: 'LIST' }],
        }),

        getSuitcaseById: builder.query<SuitcaseModelIF, GuidT>({
            query: (id) => ({
                url: `/${id}`,
            }),
            providesTags: (_result, _error, id) => [{ type: 'Suitcases', id }],
        }),

        createSuitcase: builder.mutation<SuitcaseModelIF, CreateSuitcaseIF>({
            query: (body) => ({
                url: '',
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Suitcases', id: 'LIST' }],
        }),

        updateSuitcase: builder.mutation<SuitcaseModelIF, UpdateSuitcaseIF>({
            query: (body) => ({
                url: '',
                method: 'PUT',
                body,
            }),
            invalidatesTags: (_result, _error, { guid }) => [
                { type: 'Suitcases', id: guid },
                { type: 'Suitcases', id: 'LIST' },
            ],
        }),

        deleteSuitcase: builder.mutation<void, GuidT>({
            query: (guid) => ({
                url: `/${guid}`,
                method: 'DELETE',
            }),
            invalidatesTags: () => [{ type: 'Suitcases', id: 'LIST' }],
        }),
    }),
});
